import { ApiEndPoint } from "./ApiEndPoint";

export { ApiEndPoint };
